<header class="main">
  <section class="site-layout-1">
    <div class="container">
      <div class="row">
        <div class="logo">
          <img
            src="{{ onPassiveBaseUrl }}onpassive-sept(4)/img/logo.png"
            alt="onpassive-logo"
            class="img-fluid mt-2"
            width="350"
          />
        </div>
      </div>
      <div class="row justify-content-between">
        <div class="nrev col-lg-5 text-uppercase">
          <h2 class="font-weight-bold">new revolutionized</h2>
          <h2>internet marketing solutions</h2>
        </div>
        <div class="col-lg-7">
          <div class="video-box">
            <video
              id="my-video"
              class="video-js video-size w-100 h-auto"
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
      <div class="row align-items-end justify-content-between">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="pics position-relative">
            <img
              src="{{ onPassiveBaseUrl }}onpassive-sept(4)/img/robo.png"
              class="robo img-fluid"
              alt="robo"
            />
            <img
              src="{{ onPassiveBaseUrl }}onpassive-sept(4)/img/light.png"
              class="light img-fluid"
              alt="light"
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-5">
          <div class="launch-text text-justify">
         
            <div class="text-uppercase text-center mt-5 mb-3">
              <div class="progress-container">
                <label> L </label>
                <label> A</label>
                <label> U</label>
                <label> N</label>
                <label> C</label>
                <label> H</label>
                <label> I</label>
                <label> N</label>
                <label> G</label>
                <label> </label>
                <label>&nbsp;</label>
                <label> S</label>
                <label> O</label>
                <label> O</label>
                <label> N</label>
              </div>
           
            </div>
            <h5 class="ml9">
              <span class="text-wrapper">
                <span 
                  >Do you want a life-long income while enjoying time with your
                  family? If yes, then ONPASSIVE is the perfect platform to get
                  exactly what you need. The world's most potential income
                  solution is awaiting a grand launch soon. Come.. join us
                  immediately as 576670+ people worldwide are already ahead of
                  you and more are joining everyday. You can just sit back and
                  enjoy the ride.</span
                >
              </span>
            </h5>
            <div class="bfn text-center text-uppercase mt-4">
              <a
                href="/registration/user?reg={{ userId }}"
                name="regform"
                target="_blank"
                rel="noopener"
                class="btn"
              >
                <span> become a founder now </span>
                <div class="transition"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</header>
<script src="https://cdnjs.cloudflare.com/ajax/libs/animejs/2.0.2/anime.min.js"></script>
<script>
  anime
    .timeline({
      loop: false,
    })
    .add({
      targets: ".ml5 .line",
      opacity: [0.5, 1],
      scaleX: [0, 1],
      // easing: "easeInOutExpo",
      duration: 700,
    })
    .add({
      targets: ".ml5 .line",
      duration: 600,
      easing: "easeOutExpo",
      translateY: (el, i) => -0.625 + 0.625 * 2 * i + "em",
    })
    .add({
      targets: ".ml5 .ampersand",
      opacity: [0, 1],
      scaleY: [0.5, 1],
      easing: "easeOutExpo",
      duration: 600,
      offset: "-=600",
    })
    .add({
      targets: ".ml5 .letters-left",
      opacity: [0, 1],
      translateX: ["0.5em", 0],
      easing: "easeOutExpo",
      duration: 600,
      offset: "-=300",
    })
    .add({
      targets: ".ml5 .letters-right",
      opacity: [0, 1],
      translateX: ["-0.5em", 0],
      easing: "easeOutExpo",
      duration: 600,
      offset: "-=600",
    });
  
</script>
